const DIFFS = [
    {
        t: "Tenemos un método propio. Y lleva nombre.",
        d: "Smart Sales Systems™ es una metodología desarrollada en más de diez años de venta high-ticket real, no en una pizarra. Está documentada, registrada y entrenada al equipo. La mayoría de nuestros competidores improvisa cada despliegue. Nosotros no.",
    },
    {
        t: "Llevamos entre 8 y 10 años conociéndonos.",
        d: "No nos hemos contratado por LinkedIn. Nos hemos elegido. La estabilidad de relaciones largas en un equipo pequeño no se compra ni se acelera — y se nota en cómo trabajamos contigo.",
    },
    {
        t: "Hablamos el idioma del Golfo, no solo el inglés.",
        d: "Operamos en europeo y árabe nativo. Tenemos acceso a redes institucionales en Arabia Saudí, Omán y Emiratos Árabes Unidos que ninguna firma europea puede comprar y ninguna firma árabe construye con método europeo. Si tu negocio mira al Golfo, esto importa.",
    },
    {
        t: "Más de 300 páginas de manual operativo propietario.",
        d: "Nuestra forma de vender, desplegar y entregar está documentada en detalle. Ninguna agencia de nuestro tamaño lo tiene. No vendemos transparencia — vendemos disciplina operativa demostrable.",
    },
    {
        t: "No dependemos de un solo proveedor.",
        d: "Nuestra infraestructura técnica está deliberadamente diseñada para que ninguna capa sea irremplazable. Si un proveedor cambia las reglas mañana, o cierra, nuestro método sigue funcionando. La metodología es nuestra. La tecnología es modular.",
    },
];

export default function Differentiators() {
    return (
        <section
            id="diferenciadores"
            data-testid="differentiators-section"
            className="bg-[#F4F1EA] py-28 md:py-40"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-12">
                <div className="max-w-[920px]">
                    <h2 className="font-serif-display text-4xl md:text-6xl tracking-tight text-[#1A1A1A] leading-[1.05]">
                        Lo que solo nosotros podemos decir.
                    </h2>
                    <p className="mt-5 font-serif-display italic text-lg md:text-2xl text-[#666666]">
                        No vamos a contarte que tenemos IA con criterio o supervisión humana experta. Eso lo dice todo el mundo. Lo que importa es lo que solo es verdad para Aurum:
                    </p>
                </div>

                <div className="mt-20 md:mt-24 space-y-16 md:space-y-20">
                    {DIFFS.map((d, i) => (
                        <div
                            key={i}
                            data-testid={`diff-${i}`}
                            className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start"
                        >
                            <div className="md:col-span-2">
                                <p className="font-serif-display text-5xl md:text-6xl text-[#8B6914] leading-none">
                                    {String(i + 1).padStart(2, "0")}.
                                </p>
                            </div>
                            <div className="md:col-span-10 max-w-[840px]">
                                <h3 className="font-serif-display text-2xl md:text-3xl text-[#1A1A1A] leading-tight">
                                    {d.t}
                                </h3>
                                <p className="mt-4 text-base md:text-lg text-[#666666] leading-[1.75]">
                                    {d.d}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
